// =================================================================
// Engine: Dose rounding with recompute (PSD §4.2.13 / TODO Task 2.4)
// =================================================================
import { predictPeakTrough } from './traditional';
import { ok } from './types';
/**
 * Round dose to agent increment and recompute predicted peak/trough (PSD §4.2.13).
 */
export function roundDoseAndRecompute(idealDoseMg, incrementMg, minDoseMg, maxDoseMg, kelPerHr, vdL, intervalHr, infusionDurationHr) {
    const inc = incrementMg > 0 ? incrementMg : 1;
    let roundedDose = Math.round(idealDoseMg / inc) * inc;
    let flooredToMin = false;
    let cappedAtMax = false;
    if (roundedDose < minDoseMg) {
        roundedDose = minDoseMg;
        flooredToMin = true;
    }
    if (roundedDose > maxDoseMg) {
        roundedDose = maxDoseMg;
        cappedAtMax = true;
    }
    const ptRes = predictPeakTrough(roundedDose, kelPerHr, vdL, intervalHr, infusionDurationHr);
    if (!ptRes.ok)
        return ptRes;
    return ok({
        roundedDoseMg: roundedDose,
        roundedPeak: ptRes.value.peak,
        roundedTrough: ptRes.value.trough,
        flooredToMin,
        cappedAtMax,
    });
}
//# sourceMappingURL=rounding.js.map